export const SettlementDashboardRoute = {
  path: '/Dashboard/Settlements',
  load: () => import('./SettlementDashboard'),
  protected: true,
};
